export const SOFTLINE_API_PERMISSIONS = 'v1/security/user/permissions';
